import { styled } from 'styled-components';
import { breakpoints } from '../../abstracts/breakpoints';
import { dontForwardProps } from '../../util';
export const FadeTransition = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-6xnau2-0"
})(["transition:0.2s;opacity:", ";display:", ";position:relative;"], ({
  transitionStatus
}) => transitionStatus === 'entered' ? 1 : 0, ({
  transitionStatus
}) => transitionStatus === 'exited' ? 'none' : 'block');
export const ModalActions = styled.div.withConfig({
  componentId: "aui__sc-6xnau2-1"
})(["display:flex;margin-top:0.5rem;@media only screen and (", "){flex-direction:row;justify-content:flex-end;}> button{width:100%;@media only screen and (", "){width:max-content;min-width:150px;}}> button:last-child{margin:0 0 0 0.5rem;}"], breakpoints.lgMin, breakpoints.lgMin);
export const ModalActionsLong = styled.div.withConfig({
  componentId: "aui__sc-6xnau2-2"
})(["display:flex;flex-direction:column;align-items:center;margin-top:0.5rem;> button{margin-bottom:0.5rem;min-width:100%;@media only screen and (", "){min-width:300px;}}> button:last-child{margin-bottom:0;}"], breakpoints.lgMin);
export const ModalBackground = styled.div.withConfig({
  componentId: "aui__sc-6xnau2-3"
})(["background:rgba(0,0,0,0.5);position:fixed;top:0;left:0;right:0;bottom:0;overflow-y:auto;z-index:9999;"]);
export const ModalContainer = styled.div.withConfig({
  componentId: "aui__sc-6xnau2-4"
})(["display:flex;height:100%;flex-direction:column;justify-content:center;align-items:center;position:fixed;width:100%;top:0;left:0;right:0;bottom:0;z-index:9999;"]);
export const ModalInner = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-6xnau2-5"
})(["background:white;border-radius:0.5rem;max-width:calc(100% - 3rem);width:", ";margin:auto;padding:1rem;position:relative;max-height:calc(100vh - 3rem);display:flex;flex-direction:column;z-index:9999;"], ({
  width
}) => width ? width : '560px');